// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { GoogleAuthProvider } from "firebase/auth";
import { getAuth, signInWithRedirect } from "firebase/auth";

const provider = new GoogleAuthProvider();

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAqY5ZyA8ROGuaBFv7eHXV46Hlj_ZeOnCQ",
  authDomain: "portfolio-83fb0.firebaseapp.com",
  projectId: "portfolio-83fb0",
  storageBucket: "portfolio-83fb0.appspot.com",
  messagingSenderId: "513174696847",
  appId: "1:513174696847:web:b062fbb723c2cf64fdd1fa",
  measurementId: "G-RBYNSCQB7D"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const auth = getAuth(app);

// signInWithRedirect(auth, provider);



const analytics = getAnalytics(app);

const db = getFirestore(app)
let firebaseObject = {
    db
}
export default firebaseObject